import React, { Fragment, useState, useEffect } from "react";
import styles from "./chat-buddy-auth-form.module.less";
import { ChatAuthFormProps, ActionParamAuth, ChatAuthBtns } from "../../types/chat-msg-types";
import { AccessCodePayload } from "../../types/chat-authentication-types";
import { useDispatch } from "react-redux";
import { accessCodeLoginAction } from "../../actions/chat-authentication-actions";
import { string } from "prop-types";

const ChatAuthForm: React.FC<ChatAuthFormProps> = (props: ChatAuthFormProps) => {
    const dispatch = useDispatch();
    const actionId = props.actionId;
    const type = props.type;
    const paramForm = props.paramForm;
    const isHistroyMsg = props.isHistoryMsg;
    const btns = props.btns;
    const [codeVal, setCodeVal] = useState("");
    const [pwdVal, setPwdVal] = useState("");
    const [pwdMaskVal, setPwdMaskVal] = useState("");
    useEffect(() => {
        changeStyle(type, event);
    },[codeVal, pwdMaskVal, pwdVal]);
    const authenticationSubmit = (e: React.MouseEvent<HTMLElement>, btn: ChatAuthBtns) => {
        if(codeVal && pwdMaskVal && pwdVal) {
            console.log('you can submit', btn);
            console.log("accessCode: ", codeVal, " pwdVal: ", pwdVal);
            dispatch(accessCodeLoginAction({ accessCode: codeVal, pin: pwdVal, type: type, actionId: actionId }));
        }
    }
    const changeStyle = (type: string,event: any) => {
        if(event.target.previousElementSibling) {
            if(type === 'code') {
                event.target.previousElementSibling.setAttribute("class", "inputLabel code actived");
            }else if(type === 'pin') {
                event.target.previousElementSibling.setAttribute("class", "inputLabel pwd actived");
            }
        }
        if(codeVal && pwdMaskVal && pwdVal) {
            if(event.target.parentElement?.parentElement) {
                event.target.parentElement.parentElement.getElementsByTagName("button")[0].setAttribute("class", "submit-btn actived");
            }
        }else if(event.target.parentElement?.parentElement) {
                event.target.parentElement.parentElement.getElementsByTagName("button")[0].setAttribute("class", "submit-btn disable");
            }
    }
    const inputFocus = (e: React.FocusEvent<HTMLElement>, type: string) => {
        changeStyle(type, event);
    }
    const inputChange = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        if(type === 'code') {
            console.log("access code: ", e.target.value);
            setCodeVal(e.target.value);
        } else if(type === 'pin') {
            console.log("pin: ", e.target.value);
            if(e.target.value.length >= pwdVal.length) {
                let pwd = pwdVal;
                pwd = pwd + e.target.value[e.target.value.length - 1];
                console.log("1-pwd: ", pwd);
                setPwdVal(pwd);
            } else {
                let pwd = "";
                for(let i = 0; i < e.target.value.length; i++) {
                    pwd = pwd + pwdVal[i];
                }
                console.log("2-pwd: ", pwd);
                setPwdVal(pwd);
            }
            setPwdMaskVal(new Array(e.target.value.toString().length).fill("*").join(""));
        }
    }
    return (
        <div className={styles.ChatAuthFormLess} data-testid="chat-auth-form">
            <form name={type} autoComplete="false">
                {paramForm?.map((item: ActionParamAuth) => <p key={item.title}>
                        {item.type === "input" && <Fragment>
                                <label className="inputLabel default"> {item.title}</label>
                                <input type="text" form={type} name="code" className="code" disabled={isHistroyMsg} autoComplete="off" 
                                    onFocus={(e) => inputFocus(e, "code")} onChange={(e) => inputChange(e, "code")} 
                                    value={codeVal}/>
                            </Fragment>
                        }
                        {item.type === "password" &&  <Fragment>
                                <label className="inputLabel default"> {item.title}</label>
                                <input type="text" form={type} disabled={isHistroyMsg} autoComplete="off" onFocus={(e) => inputFocus(e, "pin")} 
                                    onChange={(e) => inputChange(e, "pin")} value={pwdMaskVal} />
                                <input type="password" form={type} name="pin" className="pin" hidden autoComplete="off"
                                     value={pwdVal} onChange={() => {console.log();}}/>
                            </Fragment>
                        }
                    </p>
                )}
                {type === "pwd" && (btns?.length ?? 0) > 0 &&
                    btns.map((item, index) => 
                        <button type="button" key={`${item.title}-${item.actionCode}`} onClick={(e) => authenticationSubmit(e,item)} className="submit-btn disable" disabled={isHistroyMsg}>{item.title}</button>
                    )
                    
                }
            </form>
        </div>
    );
}

export default ChatAuthForm;